import { RootState } from 'app'

export const getCategories = (state: RootState) =>
  state.categories.getCategories

export const addCategory = (state: RootState) => state.categories.addCategory
